module.exports = "/_next/static/images/f1d029ed1a2a672730c8568f99993690-Nubank_HickDuarte_58741_lg.jpg.webp";